export default "__VITE_ASSET__vaNruwne__"